class TeamRequestsModalApproveAllController {
  constructor() {
  }

  isQuestion() {
    return !this.isError() && !this.isSuccess();
  }

  isError() {
    return this.error !== undefined && this.error !== null;
  }

  isSuccess() {
    return this.success === true;
  }
}

export default TeamRequestsModalApproveAllController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAll.controller.js